import { Link } from "react-router-dom";
import { BOOKING_URL } from "@/config/site";

export default function BlogCTA() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/images/blog-cta-bg.jpg"
          alt="Peaceful forest"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#418b86]/60"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-6 md:px-10 text-center">
        <div className="inline-flex items-center gap-2 border border-white/40 text-white/90 text-xs font-medium px-4 py-1.5 rounded-full mb-6">
          <i className="ri-sparkling-line text-sm"></i>
          Ready to Begin?
        </div>

        <h2
          className="text-3xl md:text-5xl font-light text-white leading-tight mb-5"
          style={{ fontFamily: "'Playfair Display', serif" }}
        >
          Growth is a journey,
          <br />
          <span className="italic font-semibold">not a destination.</span>
        </h2>

        <p className="text-white/80 text-base md:text-lg leading-relaxed max-w-xl mx-auto mb-8">
          Every article is a small step toward understanding yourself better. When you are ready to take the next step, we are here to walk alongside you.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={BOOKING_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-white hover:bg-[#f0f9f9] text-[#418b86] font-medium px-7 py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
          >
            Schedule a Consultation
            <i className="ri-arrow-right-line"></i>
          </a>
          <Link
            to="/services"
            className="inline-flex items-center justify-center gap-2 border border-white/50 hover:border-white text-white font-medium px-7 py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-sm backdrop-blur-sm"
          >
            Explore Our Services
          </Link>
        </div>
      </div>
    </section>
  );
}